if (!window.__nvqInit) {
  window.__nvqInit = true;
  (function () {
    var inEditor = !!(window.Shopify && window.Shopify.designMode);
    var io = null;

    function root() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
    }

    /* ---------- Reveal on scroll ---------------------------------------- */
    function revealAll(scope) {
      (scope || document).querySelectorAll('.nvq-reveal').forEach(function (el) { el.classList.add('nvq-in'); });
    }

    function initReveal(scope) {
      scope = scope || document;
      if (inEditor || !('IntersectionObserver' in window)) { revealAll(scope); return; }
      if (!io) {
        io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { e.target.classList.add('nvq-in'); io.unobserve(e.target); }
          });
        }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      }
      scope.querySelectorAll('.nvq-reveal:not(.nvq-in)').forEach(function (el) { io.observe(el); });
      /* Safety net: nothing may stay invisible, whatever happens. */
      setTimeout(function () {
        scope.querySelectorAll('.nvq-reveal:not(.nvq-in)').forEach(function (el) {
          var r = el.getBoundingClientRect();
          if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('nvq-in');
        });
      }, 1200);
    }

    /* ---------- Sticky add-to-bag --------------------------------------- */
    var stickyObserver = null;
    function initSticky() {
      var sticky = document.querySelector('[data-nvq-sticky]');
      var anchor = document.querySelector('[data-nvq-sticky-anchor]');
      if (stickyObserver) { stickyObserver.disconnect(); stickyObserver = null; }
      if (inEditor || !sticky || !anchor || !('IntersectionObserver' in window)) return;
      stickyObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          sticky.classList.toggle('nvq-in', !en.isIntersecting && en.boundingClientRect.top < 0);
        });
      }, { threshold: 0 });
      stickyObserver.observe(anchor);
    }

    /* ---------- Toast ---------------------------------------------------- */
    var toast;
    function showToast(html) {
      if (!toast) {
        toast = document.createElement('div');
        toast.className = 'nvq-toast';
        toast.setAttribute('role', 'status');
        toast.setAttribute('aria-live', 'polite');
        document.body.appendChild(toast);
      }
      toast.innerHTML = html;
      requestAnimationFrame(function () { toast.classList.add('nvq-in'); });
      clearTimeout(toast._t);
      toast._t = setTimeout(function () { toast.classList.remove('nvq-in'); }, 5000);
    }

    /* ---------- Delegated handlers (bound once on document) -------------- */
    document.addEventListener('click', function (e) {
      /* Quantity steppers */
      var qtyBtn = e.target.closest('[data-nvq-qty]');
      if (qtyBtn) {
        e.preventDefault();
        var wrap = qtyBtn.closest('.nvq-qty');
        var input = wrap && wrap.querySelector('input');
        if (input) {
          var min = parseInt(input.min || '1', 10);
          var val = parseInt(input.value || '1', 10);
          if (isNaN(val)) val = min;
          val += (qtyBtn.getAttribute('data-nvq-qty') === 'up' ? 1 : -1);
          input.value = Math.max(min, val);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return;
      }

      /* Product gallery lightbox */
      var box = document.querySelector('[data-nvq-lightbox]');
      if (box && typeof box.showModal === 'function') {
        var zoom = e.target.closest('[data-nvq-zoom]');
        if (zoom) {
          var img = box.querySelector('img');
          img.src = zoom.getAttribute('data-nvq-zoom');
          img.alt = zoom.getAttribute('data-nvq-zoom-alt') || '';
          box.showModal();
          return;
        }
        if (e.target.closest('[data-nvq-lightbox-close]') || e.target === box) box.close();
      }
    });

    /* Variant select updates the displayed price */
    document.addEventListener('change', function (e) {
      var sel = e.target.closest('[data-nvq-variant]');
      if (!sel) return;
      var opt = sel.options[sel.selectedIndex];
      var price = document.querySelector('[data-nvq-price]');
      if (opt && price && opt.dataset.price) price.textContent = opt.dataset.price;
    });

    /* Cart page: a quantity change submits the cart form */
    document.addEventListener('change', function (e) {
      var input = e.target.closest('[data-nvq-cart-qty]');
      if (!input) return;
      var form = input.closest('form');
      if (form) form.submit();
    });

    /* Add to bag — the form still posts natively if fetch is unavailable */
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[data-nvq-atc]');
      if (!form || !window.fetch) return;
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var msg = form.querySelector('.nvq-atc__msg');
      var label = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.innerHTML = 'Adding…'; }
      if (msg) msg.textContent = '';

      fetch(root() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{
            id: form.querySelector('[name="id"]').value,
            quantity: parseInt((form.querySelector('[name="quantity"]') || { value: 1 }).value, 10) || 1
          }]
        })
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.data.description || res.data.message || 'We could not add that to your bag.');
          if (btn) btn.innerHTML = 'Added ✓';
          showToast('<span>Added to your bag.</span>');
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          window.location.href = root() + 'cart';
        })
        .catch(function (err) {
          if (msg) msg.textContent = (err && err.message) ? err.message : 'Something went wrong. Please try again.';
          if (btn) { btn.disabled = false; btn.innerHTML = label; }
        });
    });

    /* ---------- Boot + re-boot inside the theme editor ------------------- */
    function boot(scope) { initReveal(scope); initSticky(); }

    if (document.readyState !== 'loading') boot(document);
    else document.addEventListener('DOMContentLoaded', function () { boot(document); });

    ['shopify:section:load', 'shopify:section:select', 'shopify:section:deselect', 'shopify:section:reorder', 'shopify:block:select', 'shopify:block:deselect'].forEach(function (evt) {
      document.addEventListener(evt, function (e) {
        var scope = (e && e.target && e.target.querySelectorAll) ? e.target : document;
        revealAll(scope);
        boot(document);
      });
    });
  })();
}
